<template>
  <div>
    <Loader v-if="loading"></Loader>
    <div class="wrraper" v-else>
      <!-- Start Breadcrumb -->
      <!-- Start Breadcrumb -->
      <Breadcrumb
        :items="items"
        :show_print="true"
        :excelFile="true"
        :excelData="excelData"
      />
      <!-- End Breadcrumb -->
      <!-- start of searchSection  -->
      <SearchSection @filterTable="searchTable"></SearchSection>
      <!-- end of searchSection  -->
      <!-- notFound  -->
      <Notfound v-if="!searchItems"></Notfound>
      <!-- Start Statistics Card-->
      <div v-else>
        <!-- Start Statistics Card-->
        <ul class="all-state-count">
          <li>
            <div class="state-count">
              <span>عدد المصروفات :</span>
              <span>{{ table_length }}</span>
            </div>
          </li>
        </ul>
        <!-- End Statistics Card-->
        <div class="table-print">
          <main class="main-table">
            <!-- start of  header of printSection  -->
            <PrintHead :title="'المصروفات'" :number="table_length"></PrintHead>
            <!-- end of header of printSection  -->
            <v-data-table
              class="thumb"
              :headers="headers"
              :items="rows"
              :search="search"
              :loading="lodaing"
              :loading-text="$t('table.loadingData')"
              v-model="selected"
              :single-select="singleSelect"
              :items-per-page="rows.length"
              item-key="id"
              hide-default-footer
            >
              <!-- ================== You Can use any slots you want ================== -->
              <!-- ====== Select row field ====== -->
              <!-- title -->
              <template v-slot:[`item.title`]="{ item }">
                <v-chip color="red">
                  {{ item.title }}
                </v-chip>
              </template>
              <!-- revision status-->
              <template v-slot:[`item.review_status`]="{ item }">
                <v-chip color="#d7c100" v-if="item.review_status == 0">
                  منتظر
                </v-chip>
                <v-chip color="green" v-else> تأكيد </v-chip>
              </template>
              <!-- Confirm revision-->
              <template v-slot:[`item.revision_done`]="{ item }">
                <!--  -->
                <div class="_actions actions2">
                  <button
                    type="button"
                    class="accept confirm_btn ml-0"
                    @click="revisionDone(item)"
                    v-if="item.review_status == 0"
                  >
                    <i class="far fa-check"></i>
                  </button>
                  <span v-else> ---- </span>
                </div>
              </template>
              <template v-slot:[`item.index`]="{ index }">
                {{ index + 1 }}
              </template>
              <!-- Select no data State -->
              <template v-slot:no-data>
                {{ $t("table.noData") }}
              </template>
              <template v-slot:[`item.amount`]="{ item }">
                {{ Number(item.amount).toLocaleString() }}
              </template>
              <template v-slot:[`item.desc`]="{ item }">
                <div class="_actions">
                  <v-icon
                    class="show"
                    small
                    @click="
                      modal.descriptionModalIsOpen = true;
                      setItemDesc(item.desc);
                    "
                  >
                    fal fa-eye
                  </v-icon>
                </div>
              </template>

              <template v-slot:[`item.notes`]="{ item }">
                <div class="_actions">
                  <span v-if="item.notes == 'null' || item.notes == null">
                    ----
                  </span>
                  <v-icon
                    class="show"
                    small
                    v-else
                    @click="
                      modal.notesModalIsOpen = true;
                      setItemNotes(item.notes);
                    "
                  >
                    fal fa-eye
                  </v-icon>
                </div>
              </template>

              <!-- Select actions-->
              <template v-slot:[`item.actions`]="{ item }">
                <div class="_actions">
                  <!-- <v-icon class="show" small @click="showItem(item)">
              fal fa-eye
            </v-icon> -->
                  <!-- <v-icon class="edit" small @click="editItem(item)">
                    fal fa-edit
                  </v-icon> -->
                  <v-icon class="delete" small @click="deleteItem(item)">
                    fal fa-trash
                  </v-icon>
                </div>
              </template>

              <!-- ======================== Start Top Section ======================== -->
              <template v-slot:top>
                <!-- Delete dialog -->
                <v-dialog v-model="dialogDelete" max-width="500px">
                  <v-card>
                    <v-card-title class="text-h5 justify-center">{{
                      $t("table.deletedialog.areYouSure")
                    }}</v-card-title>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="#1B5E20" @click="deleteItemConfirm"
                        >{{ $t("table.deletedialog.ok") }}
                        <span
                          class="btn_loader_model"
                          v-if="loadingBtnDialog"
                        ></span
                      ></v-btn>
                      <v-btn color="#F44336" @click="dialogDelete = false">{{
                        $t("table.deletedialog.cancel")
                      }}</v-btn>
                      <v-spacer></v-spacer>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
                <!-- confirm dialog -->
                <v-dialog v-model="dialogConfirm" max-width="500px">
                  <v-card>
                    <v-card-title class="text-h5 justify-center">
                      هل تمت المراجعه علي العملية ؟
                    </v-card-title>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="#1B5E20" @click="revisionConfirm"
                        >{{ $t("table.deletedialog.ok") }}
                        <span
                          class="btn_loader_model"
                          v-if="loadingBtnDialog"
                        ></span
                      ></v-btn>
                      <v-btn color="#F44336" @click="dialogConfirm = false">{{
                        $t("table.deletedialog.cancel")
                      }}</v-btn>
                      <v-spacer></v-spacer>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
                <!-- Description Modal -->
                <DescModal
                  :desc="selectedItemDesc"
                  :handelModalApperance="modal.descriptionModalIsOpen"
                  @close="closeDescModal"
                />

                <NotesModal
                  :desc="selectedItemNotes"
                  :handelModalApperance="modal.notesModalIsOpen"
                  @close="closeNotesModal"
                />

                <!-- Row -->
              </template>
              <!-- ======================== End Top Section ======================== -->
            </v-data-table>
          </main>
          <div class="showMoney" v-if="total_expence.length > 0">
            <ul class="new_ul">
              <li v-for="item in total_expence" :key="item.currency_id">
                <div class="state-count">
                  <span>إجمالي المصروفات :</span>
                  <span
                    :class="{
                      redColor: item.total < 0,
                      greenColor: item.total > 0,
                    }"
                  >
                    {{ Number(item.total).toLocaleString() }}
                    {{ item.currency.name }}
                  </span>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <!-- End Main Section -->
      </div>
      <!-- End Pagination -->
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import StatsCard from "@/components/Charts/ChartComponent.vue";
import DescModal from "@/components/modals/DescriptionModal.vue";
import NotesModal from "@/components/modals/NotesModal.vue";
import SearchSection from "@/components/Search/expenses";
export default {
  name: "AllExpenses",
  components: {
    StatsCard,
    DescModal,
    NotesModal,
    SearchSection,
  },

  data() {
    return {
      // loadingBtnDialog
      loadingBtnDialog: false,
      // search
      searchItems: null,
      // loader
      loading: true,
      // ========== Breadcrumbs
      items: [
        {
          text: this.$t("breadcrumb.mainPage"),
          disabled: false,
          href: "/",
        },
        {
          text: this.$t("breadcrumb.expenses.all"),
          disabled: true,
          href: "",
        },
      ],

      // ========== Statistics
      statisticsItems: [],

      // ========== Top Section
      search: "",

      // ========== Filter
      show_filter: false,

      // ========== dialog Status
      dialogShow: false,
      itemToShow: null,
      dialogDelete: false,
      dialogDelete_selected: false,
      itemtoDelete: null,
      dialogConfirm: false,
      itemtoConfirm: null,
      // ========== Your Data
      rows: [], // injected in created

      // ========== elected Data
      selected: [],
      singleSelect: false,

      // Custom Modal Data
      modal: {
        descriptionModalIsOpen: false,
        notesModalIsOpen: false,
      },
      selectedItemDesc: null,
      selectedItemNotes: null,

      // ========== Loding
      lodaing: false,
      table_length: null,
      total_expence: null,
      // excel data
      excelData: {
        name: "المصروفات",
        items: null,
        json_fields: {
          المبلغ: {
            field: "amount",
            callback: (value) => {
              return Number(value).toLocaleString();
            },
          },
          العملة: "currency",
          الخزنة: "theLock",
          التاريخ: "date",
          وصف: "desc",
          ملاحظات: "notes",
        },
      },
    };
  },
  computed: {
    ...mapGetters({
      lang: "lang_module/lang",
    }),

    headers() {
      if (this.lang == "ar") {
        var userType = JSON.parse(this.$store.state.usertype) || null;
        if (
          userType.includes("superadmin") ||
          (userType.includes("lock_and_deals") &&
            userType.includes("confirm_lock_and_deals"))
        ) {
          return [
            {
              text: "#",
              value: "index",
              sortable: false,
              align: "center",
              width: 10,
            },
            {
              text: "المبلغ",
              value: "amount",
              sortable: false,
              align: "center",
              width: 100,
            },
            {
              text: "العملة",
              value: "currency",
              sortable: false,
              align: "center",
              width: 100,
            },
            {
              text: "الخزنة",
              value: "theLock",
              align: "center",
              width: 100,
            },
            {
              text: "التاريخ",
              value: "date",
              align: "center",
              width: 100,
            },
            {
              text: "وصف",
              value: "desc",
              sortable: false,
              align: "center",
              class: "showOnPrint",
              cellClass: "showOnPrint",
              width: 80,
            },
            {
              text: "ملاحظات",
              value: "notes",
              sortable: false,
              align: "center",
              class: "showOnPrint",
              cellClass: "showOnPrint",
              width: 80,
            },
            {
              text: "المراجعة",
              value: "review_status",
              align: "center",
              sortable: false,
              class: "showOnPrint",
              cellClass: "showOnPrint",
              width: 50,
            },
            {
              text: "تأكيد",
              value: "revision_done",
              align: "center",
              sortable: false,
              class: "showOnPrint",
              cellClass: "showOnPrint",
              width: 50,
            },
            {
              text: "التحكم",
              value: "actions",
              sortable: false,
              align: "center",
              class: "showOnPrint",
              cellClass: "showOnPrint",
              width: 80,
            },
          ];
        } else if (!userType.includes("confirm_lock_and_deals")) {
          return [
            {
              text: "#",
              value: "index",
              sortable: false,
              align: "center",
              width: 10,
            },
            {
              text: "المبلغ",
              value: "amount",
              sortable: false,
              align: "center",
              width: 100,
            },
            {
              text: "العملة",
              value: "currency",
              sortable: false,
              align: "center",
              width: 100,
            },
            {
              text: "الخزنة",
              value: "theLock",
              align: "center",
              width: 100,
            },
            {
              text: "التاريخ",
              value: "date",
              align: "center",
              width: 100,
            },
            {
              text: "وصف",
              value: "desc",
              sortable: false,
              align: "center",
              class: "showOnPrint",
              cellClass: "showOnPrint",
              width: 80,
            },
            {
              text: "ملاحظات",
              value: "notes",
              sortable: false,
              align: "center",
              class: "showOnPrint",
              cellClass: "showOnPrint",
              width: 80,
            },
            {
              text: "المراجعة",
              value: "review_status",
              align: "center",
              sortable: false,
              class: "showOnPrint",
              cellClass: "showOnPrint",
              width: 50,
            },
            {
              text: "التحكم",
              value: "actions",
              sortable: false,
              align: "center",
              class: "showOnPrint",
              cellClass: "showOnPrint",
              width: 80,
            },
          ];
        } else {
          return [
            {
              text: "#",
              value: "index",
              sortable: false,
              align: "center",
              width: 10,
            },
            {
              text: "المبلغ",
              value: "amount",
              sortable: false,
              align: "center",
              width: 100,
            },
            {
              text: "العملة",
              value: "currency",
              sortable: false,
              align: "center",
              width: 100,
            },
            {
              text: "الخزنة",
              value: "theLock",
              align: "center",
              width: 100,
            },
            {
              text: "التاريخ",
              value: "date",
              align: "center",
              width: 100,
            },
            {
              text: "وصف",
              value: "desc",
              sortable: false,
              align: "center",
              class: "showOnPrint",
              cellClass: "showOnPrint",
              width: 80,
            },
            {
              text: "ملاحظات",
              value: "notes",
              sortable: false,
              align: "center",
              class: "showOnPrint",
              cellClass: "showOnPrint",
              width: 80,
            },
            {
              text: "المراجعة",
              value: "review_status",
              align: "center",
              sortable: false,
              class: "showOnPrint",
              cellClass: "showOnPrint",
              width: 50,
            },
            {
              text: "تأكيد",
              value: "revision_done",
              align: "center",
              sortable: false,
              class: "showOnPrint",
              cellClass: "showOnPrint",
              width: 50,
            },
          ];
        }
      }
    },
  },

  methods: {
    // searchTable
    searchTable(items) {
      this.rows = [];
      this.searchItems = items;
      this.setRows();
    },
    setItemDesc(desc) {
      this.selectedItemDesc = desc;
    },
    setItemNotes(notes) {
      this.selectedItemNotes = notes;
    },
    closeDescModal() {
      this.modal.descriptionModalIsOpen = false;
    },
    closeNotesModal() {
      this.modal.notesModalIsOpen = false;
    },

    // ==================== Start CRUD ====================
    addItem() {
      this.$router.push({ path: "/expenses/add" });
    },
    showItem(item) {
      this.dialogShow = true;
      this.itemToShow = item;
    },
    editItem(item) {
      this.$router.push({ path: "/expenses/edit/" + item.id });
    },
    // confirm item
    revisionDone(item) {
      this.dialogConfirm = true;
      this.itemtoConfirm = item;
    },
    revisionConfirm() {
      this.loadingBtnDialog = true;
      this.$axios({
        method: "POST",
        url: `client/expense/review/${this.itemtoConfirm.id}`,
      })
        .then(() => {
          this.loadingBtnDialog = false;
          this.setRows();
          this.dialogConfirm = false;
          this.$iziToast.success({
            timeout: 2000,
            message: "تم التأكيد بنجاح",
            position: "topRight",
          });
        })
        .catch((err) => {
          this.dialogConfirm = false;
          this.$iziToast.error({
            timeout: 2000,
            message: err.response.data.message,
            position: "topRight",
          });
        });
    },
    // ===== Delete
    deleteItem(item) {
      this.dialogDelete = true;
      this.itemtoDelete = item;
    },
    deleteItemConfirm() {
      this.loadingBtnDialog = true;
      this.$axios({
        method: "DELETE",
        url: `client/expense/${this.itemtoDelete.id}`,
      })
        .then(() => {
          this.loadingBtnDialog = false;
          this.setRows();
          this.dialogDelete = false;
          this.$iziToast.success({
            timeout: 2000,
            message: this.$t("CRUD.Delete"),
            position: "topRight",
          });
          this.$store.dispatch("getTranshState");
        })
        .catch((err) => {
          this.dialogDelete = false;
          this.$iziToast.error({
            timeout: 2000,
            message: err.response.data.message,
            position: "topRight",
          });
        });
    },
    // ==================== End CRUD ====================

    // ================ Set Rows
    setRows() {
      this.lodaing = true;
      this.$axios({
        method: "GET",
        url: "client/expense",
        params: {
          wallet_id: this.searchItems ? this.searchItems.lockId : null,
          currency_id: this.searchItems ? this.searchItems.currencyId : null,
          from_date: this.searchItems ? this.searchItems.from : null,
          to_date: this.searchItems ? this.searchItems.to : null,
        },
      })
        .then((res) => {
          this.total_expence = res.data.total;
          this.rows = res.data.data.map((item) => {
            return {
              id: item.id,
              amount: item.amount,
              currency: item.currency.name_ar,
              theLock: item.wallet.name,
              date: item.date,
              desc: item.desc,
              notes: item.notes,
              review_status: item.review_status,
            };
          });
          this.table_length = this.rows.length;
          this.excelData.items = this.rows;
          this.excelData.footer = [];
          this.total_expence.forEach((val) => {
            this.excelData.footer.push(
              "اجمالي المصروفات : " +
                " " +
                Number(val.total).toLocaleString() +
                val.currency.name
            );
          });
          this.lodaing = false;
        })
        .catch((err) => {
          this.lodaing = false;
        });
    },
  },

  // ======= hooks
  created() {
    setTimeout(() => {
      this.loading = false;
    }, 1000);
    // permisions
    var userType = JSON.parse(this.$store.state.usertype) || null;
    if (
      !userType.includes("superadmin") &&
      !userType.includes("lock_and_deals") &&
      !userType.includes("confirm_lock_and_deals")
    ) {
      this.$router.push("/");
    }
  },
};
</script>

<style lang="scss" scoped></style>
